import { render } from "./ImpersonationOrdersHistoryUserProduct.vue?vue&type=template&id=5b1c3370"
import script from "./ImpersonationOrdersHistoryUserProduct.vue?vue&type=script&lang=js"
export * from "./ImpersonationOrdersHistoryUserProduct.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__